import styled from 'styled-components';
import { Button as DefButton } from '../../buttons';

export const Button = styled(DefButton)`
  margin-top: auto;
  & button {
    padding: 13px 14px;
  }
`;
